import { Component, HostListener, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { INavigationItem } from '@app/main/interfaces';
import { NavigationService } from '@app/main/navigation.service';

@Component({
  selector: 'cm-navigation-section-menu',
  templateUrl: './navigation-section-menu.component.html',
  styleUrls: ['./navigation-section-menu.component.scss'],
})
export class NavigationSectionMenuComponent implements OnInit {
  @Input() navigationItems: INavigationItem[];
  @Output() clickEvent = new EventEmitter<INavigationItem>();
  @Output() clickOutEvent = new EventEmitter<string>();

  private wasInside = false;

  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
    this.wasInside ? this.clickOutEvent.emit('') : (this.wasInside = false);
  }

  constructor(public navigationService: NavigationService) {}
  ngOnInit(): void {
    setTimeout(() => {
      // <<<---using ()=> syntax
      this.wasInside = true;
    }, 250);
  }

  trackNavigateEvent(navigationItem: INavigationItem): void {
    this.clickEvent.emit(navigationItem);
  }
}
